module.exports = __webpack_public_path__ + "img/2721f760-8aec-45de-9848-c11b058ce991.cf6a3830.png";